import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboClienteConVerracosEnPropiedad`, method: 'GET', body: null, token: token})
}